import { Phone, MessageCircle, CalendarClock } from "lucide-react";
import { BRAND, IMG, waLink } from "@/lib/brand";

export const Hero = () => (
  <section className="relative overflow-hidden grain">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 pb-20 lg:pt-24 lg:pb-28 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-7">
        <p className="rise text-[11px] uppercase tracking-[0.28em] text-[#997316] font-semibold">Roma e provincia · Ritiro a domicilio e in clinica</p>
        <h1 className="rise rise-1 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#0D3B52] leading-[1.05] mt-5">
          Un ultimo saluto,<br /><em className="font-normal text-[#B8860B]">con tutto il rispetto</em> che merita.
        </h1>
        <p className="rise rise-2 text-base sm:text-lg text-[#5C6B73] mt-6 max-w-xl leading-relaxed">
          Il nostro non è un lavoro ma una missione. Ci prendiamo cura del tuo compagno di vita con servizi di cremazione singola e collettiva, ritiro della salma e restituzione delle ceneri in urna.
        </p>
        <div className="rise rise-3 flex flex-wrap gap-3 mt-9">
          <a href="#prenota" data-testid="hero-book-button" className="inline-flex items-center gap-2 rounded-full bg-[#0D3B52] hover:bg-[#082535] px-7 py-3.5 text-white font-semibold transition-colors">
            <CalendarClock className="h-5 w-5" /> Prenota un ritiro
          </a>
          <a href={BRAND.phoneHref} data-testid="hero-call-button" className="inline-flex items-center gap-2 rounded-full border border-[#0D3B52]/25 px-7 py-3.5 text-[#0D3B52] font-semibold hover:border-[#D4AF37] transition-colors">
            <Phone className="h-5 w-5" /> {BRAND.phone}
          </a>
          <a href={waLink(BRAND.wa, "Buongiorno, vorrei informazioni sui vostri servizi.")} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-button" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1DA851] px-7 py-3.5 text-white font-semibold transition-colors">
            <MessageCircle className="h-5 w-5" /> WhatsApp
          </a>
        </div>
      </div>
      <div className="lg:col-span-5 relative rise rise-2">
        <div className="hidden sm:block absolute -inset-4 rounded-[2.5rem] border border-[#D4AF37]/40 rotate-2" />
        <img src={IMG.ricordo} alt="Ricordo del proprio animale" className="relative rounded-[2rem] w-full h-[420px] sm:h-[520px] object-cover shadow-2xl" />
        <div className="absolute -bottom-6 -left-4 sm:-left-10 bg-white rounded-2xl shadow-xl border border-[#E2DDD5] px-6 py-4">
          <p className="font-display text-3xl font-semibold text-[#0D3B52]">7 giorni su 7</p>
          <p className="text-xs text-[#5C6B73]">Ritiri dalle 9:00 alle 18:00</p>
        </div>
      </div>
    </div>
  </section>
);
